import React, {useState} from "react";
import Box from "@mui/material/Box";
import { TextField, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
	getQuotaForApproval,
	rejectQuota,
	setState,
} from "./quotaSlice";
import DeleteIcon from '@mui/icons-material/Delete';

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	boxShadow: 24,
	borderRadius: 1,
	p: 3,
};

export default function RejectSingleModal() {
	const dispatch = useDispatch();
	const [uploadedEditFile, setuploadedEditFile] = useState([]);
	const {
		rejectSingleModalOpen,
		rejectSelectedComment,
		quotaDetailsTable,
		quotaForApprovalTable,
		quotaForApproval,
		selectedCountryID,
		selectedPeriod,
		selectedQuotaStatus,
		selectedQuotaid,
		files,
		searchText
	} = useSelector((store) => store.quota);


	const handleOpen = () => {
		dispatch(setState("rejectSingleModalOpen", true));
	};
	function setComment(event) {
		const comment = event.target.value;
		dispatch(setState("rejectSelectedComment", comment));
	}
	const handleClose = () => {
		dispatch(setState("rejectSingleModalOpen", false));
		dispatch(setState("selectedQuotaid", null));
		dispatch(setState("rejectSelectedComment", ''));
		dispatch(setState("files",[]));
		setuploadedEditFile([]);
	};

	function search() {
		dispatch(setState("quotaCustomerBreakdown", null));
		dispatch(setState("quotaDetailsTable", null));
		dispatch(setState("rejectSelectedComment", ''));
		dispatch(setState("selectedRows", []));
		dispatch(setState("selectedQuotaid", null));
		dispatch(setState("files",[]));
		setuploadedEditFile([]);
		const logedUser = JSON.parse(localStorage.getItem("data"));
		const countryId = selectedCountryID;
		const period = selectedPeriod;
		const quotaStatus = selectedQuotaStatus;

		const obj = {
			countryId,
			period,
			quotaStatus,
			logedUser,
			searchText: searchText
		};
		dispatch(getQuotaForApproval(obj));
	}

	function preparePayload() {

		const quota = quotaForApproval.find(
			(q) => q.quotaId === selectedQuotaid
		);
		const user = JSON.parse(localStorage.getItem("data"));
		const country = user.userCountries.find(
			(index) => index.country.countryID === quota.geoId
		).country;

		const formData = new FormData();

		formData.append("countryID", country.countryID);
		formData.append("countryName", country.countryName);
		formData.append("countryCode", country.countryCode);
		formData.append(
			"countrySalesOrganizationCode",
			country.countrySalesOrganizationCode
		);
		formData.append("quotaId", quota.quotaId);
		formData.append("scenarioId", quota.scenarioId);
		formData.append("scenarioName", quota.scenarioName);
		formData.append("geoId", quota.geoId);
		formData.append("creationDate", quota.creationDate);
		formData.append("quotaStatus", quota.quotaStatus);
		formData.append("lastActionDate", quota.lastActionDate);
		formData.append("lastActionBy", quota.lastActionBy);
		formData.append("createdDate", quota.createdDate);
		formData.append("createdBy", quota.createdBy);
		formData.append("effectiveStartDate", quota.effectiveStartDate);
		formData.append("effectiveEndDate", quota.effectiveEndDate);
		formData.append("periodType", quota.periodType);
		formData.append("isSubmitLocked", quota.isSubmitLocked);
		formData.append("revisedQuota", quota.revisedQuota);
		formData.append("period", quota.period);
		formData.append("rejectComments", rejectSelectedComment);
		formData.append("user[userID]", user.userID);
		formData.append("user[firstName]", user.firstName);
		formData.append("user[lastName]", user.lastName);
		formData.append("user[email]", user.email);
		formData.append("user[roleID]", user.roleID);
		formData.append("user[roleName]", user.roleName);
		formData.append("user[isAdmin]", user.isAdmin);
		formData.append("user[activeFlag]", user.activeFlag);
		formData.append("user[isFirstTimeUser]", user.isFirstTimeUser);
		formData.append("user[passwordChangeDate]", user.passwordChangeDate);
		formData.append("user[isIMSUser]", user.isIMSUser);
		for (var i = 0; i < files.length; i++) {
			formData.append("files", files[i]);
		}
		user.userCountries.forEach((country, index) => {
			formData.append(
				`user[userCountries][${index}][userID]`,
				country.userID
			);
			formData.append(
				`user[userCountries][${index}][country][countryID]`,
				country.country.countryID
			);
			formData.append(
				`user[userCountries][${index}][country][countryName]`,
				country.country.countryName
			);
			formData.append(
				`user[userCountries][${index}][country][countryCode]`,
				country.country.countryCode
			);
			formData.append(
				`user[userCountries][${index}][country][countrySalesOrganizationCode]`,
				country.country.countrySalesOrganizationCode
			);
		});

		user.userCustomerTypes.forEach((type, index) => {
			formData.append(
				`user[userCustomerTypes][${index}][userID]`,
				type.userID
			);
			formData.append(
				`user[userCustomerTypes][${index}][customerTypeBO][customerTypeCode]`,
				type.customerTypeBO.customerTypeCode
			);
			formData.append(
				`user[userCustomerTypes][${index}][customerTypeBO][customerTypeName]`,
				type.customerTypeBO.customerTypeName
			);
		});
		formData.append("user[token]", user.token);
		formData.append("criticalityId", quota.criticalityId);
		formData.append("canApproveReject", true);

		return formData;
	}

	function reject() {
		const quota = quotaForApproval.find(
			(q) => q.quotaId === selectedQuotaid
		);
		if (quota.revisedQuota <= 0) {
			showMessage("Please enter the revised quota", "info");
			return;
		}
		const formData = preparePayload();
		for (const pair of formData.entries()) {
			console.log(pair[0] + ", " + pair[1]);
		}
		dispatch(rejectQuota(formData)).then(() => {
			handleClose();
			search();
		});
	}
	const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};
	const handleFileUpload = (event) => {
		const fileObj = event.target.files[0];
		let files = [...uploadedEditFile];
		files.push(fileObj);
		setuploadedEditFile(files);
		dispatch(setState("files", files));
	};
	
	const handleDelete = (name) => {
		const files = uploadedEditFile.filter((file) => file.name !== name);
		setuploadedEditFile(files);
		dispatch(setState("files", files));
	};


	return (
		<div>
			<Modal
				open={rejectSingleModalOpen}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Typography variant="subtitle2">Comments</Typography>
					<TextField
						className={'fullWidth'}
						size="large"
						multiline
						rows={6}
						style={{overflowY:'auto'}}
						value={rejectSelectedComment}
						onChange={setComment}
					/>
					<br />
					<Grid item>
						<Box>
							<input
								type="file"
								onChange={handleFileUpload}
								style={{ display: 'none' }}
								id="fileInput"
								onclick="fileInput.value = null"
								value=""
							/>
							<label htmlFor="fileInput">
								<Button
									variant="contained"
									sx={{
										bgcolor: "grey.lighter",
										color: "darkred.light",
										textTransform: "none",
										mt: 1,
										"&:hover": {
											bgcolor: "darkred.main",
											color: "white.main",
										},
									}}
									component="span"
								>
									Upload File
								</Button>
							</label>
						</Box>
					</Grid>
					<Grid>
							{uploadedEditFile.map((file) => (
							<Box sx={{ mt: 2, borderBottom: 0.25, borderColor: "#e0e0e0" }}>
								<div className="file-display" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<span>{file.name}</span>
									{/* <Button variant="outlined" color="secondary" onClick={() => handleDelete(file.name)}> */}
									<DeleteIcon onClick={() => handleDelete(file.name)} sx={{ cursor: "pointer" }} />
									{/* </Button> */}
								</div>
							</Box>
						))}
					</Grid>
					<br />
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "flex-end",
						}}
					>
						<Button
							   sx={{
								bgcolor: "darkred.light",
								color: "white.main",
								textTransform: "none",
								fontWeight: "bold",
								mt: 1,
								mr:2,
								"&:hover": {
								bgcolor: "darkred.main",
								color: "white.main",
								},
							 }}
							onClick={handleClose}
						>
							Close
						</Button>

						<Button
							   sx={{
								bgcolor: "darkred.light",
								color: "white.main",
								textTransform: "none",
								fontWeight: "bold",
								mt: 1,
								"&:hover": {
								bgcolor: "darkred.main",
								color: "white.main",
								},
							 }}
							onClick={reject}
						>
							Reject
						</Button>
					</Box>
				</Box>
			</Modal>
		</div>
	);
}
